/// <reference no-default-lib="true" />
/// <reference lib="esnext" />
/// <reference lib="dom" />

export function initJumpLinks() {
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  )
  const anchors = document.querySelectorAll<HTMLAnchorElement>(
    'a[href^="#jump-"]',
  )

  anchors.forEach((anchor) => {
    anchor.addEventListener('click', (e) => {
      e.preventDefault()
      const target = document.querySelector(anchor.hash)
      target?.scrollIntoView({
        behavior: prefersReducedMotion.matches ? 'instant' : 'smooth',
      })
    })
  })
}
